/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'delete': {
    width: 12,
    height: 18,
    viewBox: '0 0 12 18',
    data: '<path pid="0" d="M7.932 1.431v.775h-.59v-.775H4.516v.775h-.59v-.775c0-.319.266-.58.59-.58h2.828c.324 0 .59.261.59.58zM1.097 4.82h9.663v11.707c0 .32-.265.58-.59.58H1.688a.585.585 0 0 1-.59-.58V4.819zM3.49 15.704V6.221c0-.16-.133-.29-.295-.29a.293.293 0 0 0-.295.29v9.483c0 .16.133.29.295.29.162 0 .295-.13.295-.29zm2.733 0V6.221c0-.16-.13-.29-.295-.29a.294.294 0 0 0-.295.29v9.483c0 .16.133.29.295.29.165 0 .295-.13.295-.29zm2.737 0V6.221c0-.16-.133-.29-.295-.29a.291.291 0 0 0-.295.29v9.483c0 .16.13.29.295.29.162 0 .295-.13.295-.29zm2.19-12.918c.162 0 .295.13.295.29v.871a.293.293 0 0 1-.295.29H.708a.293.293 0 0 1-.295-.29v-.87a.293.293 0 0 1 .295-.29h10.44z" _fill="#A1A0A0" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/delete.js